import { signUp, signUpConfirm } from '../../../services/SignUpService';

export const USER_SIGNUP = 'USER_SIGNUP';
export const USER_SIGNUP_CONFIRM = 'USER_SIGNUP_CONFIRM';

const signUpAction = (
    firstName,
    lastName,
    companyName,
    username,
    password,
    errorMessageHandler
) => ({
    type: USER_SIGNUP,
    payload: signUp(firstName, lastName, companyName, username, password, errorMessageHandler),
});

const signUpConfirmAction = (username, code, errorMessageHandler) => ({
    type: USER_SIGNUP_CONFIRM,
    payload: signUpConfirm(username, code, errorMessageHandler),
});

export { signUpAction as signUp, signUpConfirmAction as signUpConfirm };
